import type { Exercice } from '@mairistem/comptabilite';
import { request } from '@mairistem/tools';

export const getExercice = async (identifiantExercice: number) =>
	request.get<unknown, Exercice>(
		`/api/finances/comptabilite/parametrescomptabilites/exercices/${identifiantExercice}`,
	);

export default getExercice;
